import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'
import main_routes from './main_routes'
import {sync} from 'vuex-router-sync'

import app_mixins from "resources/js/assets/mixins";

Vue.use(VueRouter);
Vue.mixin(app_mixins);

import Snotify from 'vue-snotify';
import snotify_config from '../configs/snotify_config';
Vue.use(Snotify, snotify_config);

/*
 |--------------------------------------------------------------------------
 | Load Routes and initialise vue-router
 |--------------------------------------------------------------------------
 */

const routes = main_routes;
const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes
});

// Sync Vuex and vue-router;
sync(store, router);

/*
 |--------------------------------------------------------------------------
 | Check if user is authenticated and allow to see the routes as specified
 |--------------------------------------------------------------------------
 */

//NB the client / legacy views already open in single view mode (no tabs) - see layout.vue
const standaloneRoutes = new Set([
    'a_timesheet_r2_import_timesheets',
    'c_timesheet_r2_import_timesheets',
    'x_timesheet_r2_import_timesheets',

    'a_timesheet_import_processing',
    'c_timesheet_import_processing',
    'x_timesheet_import_processing',

    'a_timesheet_import_preview',
    'c_timesheet_import_preview',
    'x_timesheet_import_preview'
]);

const noSidebarRoutes = standaloneRoutes;

router.beforeEach(async (to, from, next) => {
    // if((window.feVersion && window.beVersion) && (window.feVersion !== window.beVersion)){
    //     if (confirm("The Orca frontend version is old. We must refresh the page to ensure you get the best experience.!")) {
    //         window.location.reload(true);
    //     }
    // }

    if (standaloneRoutes.has(to.name)) {
        to.meta.forceStandaloneView = true;
    } else {
        delete to.meta.forceStandaloneView; // defensive reset
    }


    if (noSidebarRoutes.has(to.name)) {
        to.meta.noSidebarRoute = true;
    } else {
        delete to.meta.noSidebarRoute; // defensive reset
    }

    if (to.path !== '/login') {
        // check if user data in store and if auth_checked is true or not
        if (!store.state.auth.me && !store.state.auth.auth_checked) {
            await store.dispatch('check_login').catch(err => {
                // not authorised and can't login therefore return to login page
                return next({path: '/login'})
            })
        }

        if (store.state.auth.me !== null) {

            // Check we are logged in and authorised
            axios.get('/api/v1/user/crm/check', {
                params: {
                    user_id: store.state.auth.me.id
                }
            }).then(res => {
                if (!res.data.hard_reload) {
                    axios.post('/api/v1/user/crm/updated', {
                        user_id: store.state.auth.me.id
                    }).
                    then(() => window.location.reload(true))
                }
            },(error) => {

                // If an error has occurred we are likely unauthenticated.
                if (error.response) {
                    if (error.response.status === 401 && error.response.data.message === 'Unauthenticated.') {
                        window.location.href = '/login';
                    }
                }
            });

            // Also check if we are signed in to MSGRAPH
            const me = store.state.auth.me;
            if (me.roles.includes('admin') && me.roles.includes('admin') && false) {
                await axios.get(app_mixins.data().crmApiPath + 'msgraph/sign_in').then(response => {
                    if (response.data.is_redirect) {
                        window.location.href = response.data.redirect_url;
                    }
                })
            }
        } else {
            window.location.href = '/login';
        }
    }
    // catch for unnamed routes (deal with ms 265 emails)
    if (to.path === '/login' || to.path === '/' || to.path === '/logout') {
        next();
    }
    else if (to.name !== undefined) {
        next()
    }
});

router.afterEach((to, from) => {
    if (to.meta.title) {
        document.title = process.env.MIX_APP_NAME + ' - ' + to.meta.title;
    }
});

export default router
